import { message } from 'antd';
import { encryptPkca1 } from '../utils/rsa';
import request from '../utils/request';

interface ChangePassword {
  username: string;
  oPassword: string;
  nPassword: string;
  confirm: string;
}

function usePasswordEncrypt() {
  function changePasswordEncrypt(data: ChangePassword) {
    console.log(data);
    return request.getWMessage(`/oauth/sys/loginPre?username=${data.username}`).then((res: any) => {
      if (res.error) {
        message.error(res.msg);
        return Promise.reject(res);
      }
      const oPassword = encryptPkca1(res.data, data.oPassword.trim());
      const nPassword = encryptPkca1(res.data, data.nPassword.trim());
      return Promise.resolve({
        ...data,
        oPassword,
        nPassword,
        confirm: nPassword,
        username: data.username.trim(),
      });
    });
  }

  return {  changePasswordEncrypt };
}

export default usePasswordEncrypt;
